module.exports = __webpack_public_path__ + "static/media/4ODA19.f679dfb6.jpg";